//
// DataSet.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "./Column";
import "../../warnings/Warning";
import "./RowStates";

var DataSet = createModule("commons::DataSet", [], EventDispatcher, [
    {
        DATASET_INVALID_EXPSILON: 10007,
        CHANGED: 10013,
        DATASET_NULL_COLUMN: 10009,
        COLUMN_INVALID_FORMAT: 10016,
        DATASET_ZERO_COLUMNS: 10006,
        DATASET_NONRECTANGULAR: 10010,
        COLUMN_DUPLICATE_LABEL: 10014,
        DATASET_EXTREME_EPSILON: 10008,
        COLUMN_INVALID_USAGE: 10017,
        DATASET_NO_NAME: 10005,
        COLUMN_NO_NAME: 10011,
        COLUMN_UNDEFINED_DATA_TYPE: 10018,
        COLUMN_NO_LABEL: 10013,
        COLUMN_DUPLICATE_NAME: 10012,
        COLUMN_NO_FORMAT: 10015,
    },
    ,
    ,
    {
        orderedUniqueStringValues: [7],
        comparisonEpsilon: 6,
        name: 7,
    },
    {
        setColumns: [0,[1]],
        _selectRows_ob: [0,[3],2],
        printTable: [0,4],
        getRowStates: [1],
        computeTotals: [0,1],
        update: [0],
        getColumnWithName: [1,7],
        getColumns: [[1]],
        getStringColumns: [[1]],
        getColumnAtIndex: [1,4],
        assignStringValuesFromIndices: [0],
        getNumberOfRows: [3],
        getCombinedCSV: [7],
        getIndexedCSV: [7],
        setColumnAtIndex: [0,1,4],
        validate: [[1],2],
        _selectRows_nb: [0,4,2],
        addColumn: [0,1],
        getSortIndexForString: [4,7],
        descriptionTable: [7,4,2,2,2],
        getNumberColumns: [[1]],
        getStringTableCSV: [7],
        getNumberOfColumns: [3],
        filter: [1,1],
        getFormattedValueAtIndex: [7,4,4],
        getColumnWithLabel: [1,7],
        print: [0],
        selectionContainsAllOther: [2],
        clone: [1],
    },
    {
        _create_obb: [4,[1],2,2],
        _create_on: [4,1,4],
        _create_s: [4,7],
        _create_bb: [4,2,2],
        createFromBase64SerialData: [1,7],
        serializeAsBase64String: [7,1],
    },
    ["selectRows"],
    ["_create"]
]);
export default DataSet;
